import type { OrderRead } from "@classes-service-types/order-read";
import { type MaybeRef, unref } from "vue";
import type { LocationQueryValue } from "vue-router";

const hasValue = (value?: any): boolean => {
  if (value === undefined || value === null) {
    // a boolean of false is still a valid value
    return false;
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  } else if (typeof value === "string") {
    return value.trim().length > 0;
  }
  return true;
};

export const areAllFieldsInObject = (requiredFields: string[], obj: any): boolean => {
  if (requiredFields.length > 0) {
    return requiredFields.every((field) => {
      return field in obj && hasValue(obj[field]);
    });
  }
  return true;
};

interface FormioPatch {
  op: "add" | "remove" | "update";
  path: string;
  value: string;
}

export const patchFormioObject = (fieldName: string = "", value: string = ""): FormioPatch => {
  // fieldName should match the name of the field in formio
  // value is the new value to assign
  return {
    op: "add",
    path: "/data/" + fieldName,
    value: value,
  };
};

interface OrderParams {
  rooms?: string[];
  event_occurrences?: string[];
  internships?: string[];
  credits?: number;
  misc_products?: string[];
  homeInstitutionId?: string;
}

export const buildOrderQueryParams = (order: MaybeRef<OrderRead> | undefined): OrderParams => {
  if (!order) {
    return {};
  }
  const orderValue: OrderRead = unref(order);
  return {
    rooms: orderValue.room_ids,
    event_occurrences: orderValue.event_occurrence_ids,
    internships: orderValue.internship_ids,
    credits: orderValue.credits,
    misc_products: orderValue.misc_product_ids,
    homeInstitutionId: orderValue.home_institution_id,
  };
};

export const getSingleParam = (param: LocationQueryValue | LocationQueryValue[] | undefined): string | undefined => {
  if (param == null) return undefined;
  if (Array.isArray(param)) {
    const first = param[0];
    return first ?? undefined;
  }
  if (!param) return undefined;
  return param;
};
